































import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import PageFetchHook from '@/components/mixins/PageFetchHook';
import store from '@/store';
import * as CvPreviewStore from '@/store/modules/cvPreview';
// @ts-ignore
import PageLeftHook from '@/components/mixins/PageLeftHook.vue';
import { CvCvSectionWithSection } from '@/containers/cv/store';
import { i18n, i18nHints } from '@/plugins/i18n';
// @ts-ignore
import CvPreviewWrapper from '@/components/section-preview/CvPreviewWrapper.vue';
import CvPreviewActions from '@/pages/cvs/_cvId/preview/-components/CvPreviewActions.vue';
import CvPreviewNavSp from '@/pages/cvs/_cvId/preview/-components/CvPreviewNavSp.vue';
import CvShareModal from '@/containers/modals/cv-share/index.vue';
import { RESIZE_LISTENERS, SP_WIDTH } from '@/utils/constants';

const { mapGetters } = createNamespacedHelpers(CvPreviewStore.namespace);

const fetch = async params => {
  const { cv_id } = params;
  // TODO copy state from edit page
  await Promise.all([
    store.dispatch(CvPreviewStore.GetCv.namespaced({ cv_id })),
    store.dispatch(CvPreviewStore.GetCvCvSections.namespaced({ cv_id })),
    store.dispatch(CvPreviewStore.GetCvSectionProfile.namespaced({ cv_id })),
  ]);
};

export default Vue.extend({
  components: {
    CvPreviewWrapper,
    CvPreviewActions,
    CvPreviewNavSp,
    CvShareModal,
  },
  mixins: [PageLeftHook, PageFetchHook(fetch)],
  data() {
    return {
      storeList: [CvPreviewStore],
      isPageBreakMode: false,
      cvShareModalOpened: false,
      windowInnerWidth: window.innerWidth,
    };
  },
  computed: {
    ...mapGetters(['cv', 'cvSections', 'cvSectionProfile', 'cvDesignTemplate']),
    isSpWidth(): boolean {
      return this.windowInnerWidth < SP_WIDTH;
    },
  },
  mounted() {
    this.initCvPreview();
  },
  destroyed() {
    this.clearCvPreview();
  },
  methods: {
    initCvPreview() {
      RESIZE_LISTENERS.forEach(type =>
        window.addEventListener(type, this.setWindowInnerWidth, false)
      );
    },
    clearCvPreview() {
      RESIZE_LISTENERS.forEach(type =>
        window.removeEventListener(type, this.setWindowInnerWidth, false)
      );
    },
    setWindowInnerWidth() {
      this.windowInnerWidth = window.innerWidth;
    },
    onClickSpDesign() {
      this.$router.push({ name: 'cv_design_path', cv_id: this.cv.id });
    },
    onClickSpShare() {
      this.cvShareModalOpened = true;
    },
    onClickSpPDF() {
      window.open(`/p/${this.cv.original_path}.pdf`, '_blank');
    },
    onClickPageBreak() {
      this.isPageBreakMode = !this.isPageBreakMode;
    },
    onClickPrint() {
      window.print();
    },
    async onSubmitPageBreak({
      cvCvSection,
      hasNowPageBreak,
    }: {
      cvCvSection: CvCvSectionWithSection;
      hasNowPageBreak: boolean;
    }) {
      // toggle page break
      const pageBreak = !hasNowPageBreak;
      const {
        cv_section_id: target_section_id,
        cv_section_type: target_section_type,
      } = cvCvSection;
      await this.$store.dispatch(
        CvPreviewStore.UpdateCvPageBreaks.namespaced({
          cvId: this.cv.id,
          body: {
            page_break: pageBreak,
            target_section_id,
            // FIXME
            target_section_type: target_section_type as any,
          },
        })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.updated));
    },
  },
});
